import request from '@/utils/request'

export function sendRobotMessage(data) {
  return request({
    url: '/app/customerService/sendMessage',
    method: 'post',
    data: data
  })
}
